import React, { useState } from 'react';

const AdminAuth = ({ onAuthenticate }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Change this password to your desired admin password
  const ADMIN_PASSWORD = 'abcd2025';

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === ADMIN_PASSWORD) {
      onAuthenticate(true);
      sessionStorage.setItem('cakified_admin', 'true');
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  return (
    <div className="admin-auth">
      <div className="auth-container">
        <div className="auth-header">
          <img src="/logo.png" alt="Cakified Logo" />
          <h2>Admin Portal</h2>
          <p>Enter password to access the admin dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              autoComplete="current-password"
              autoFocus
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="btn btn-primary">
            Login
          </button>
        </form>

        <div className="auth-footer">
          {/* <p>Default password: cakified2025</p>
          <p className="security-note">
            ⚠️ Change the password in AdminAuth.jsx before deploying
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default AdminAuth;
